import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/api/company/list',
    method: 'post',
    params: query
  })
}

export function companyFrozen(data) {
  return request({
    url: '/api/company/frozen',
    method: 'post',
    params: data
  })
}

export function createCompany(data) {
  return request({
    url: '/api/company/add',
    method: 'post',
    data
  })
}

export function updateCompany(data) {
  return request({
    url: '/api/company/update',
    method: 'post',
    data
  })
}

export function addCharge(data) {
  return request({
    url: '/api/member/charge',
    method: 'post',
    data
  })
}

export function addRefund(data) {
  return request({
    url: '/api/member/refund',
    method: 'post',
    data
  })
}

export function fetchTotalCompany(data) {
  return request({
    url: '/api/company/fetchTotalCompany',
    method: 'post',
    data
  })
}
